import {
  NOT
} from '../../Boolean.lib';
import {
  getConfiguration,
  upsertConfiguration
} from '../../Configuration.lib';
import globalErrorHandler from '../../Error/globalErrorHandler.fun';
import {
  Obj
} from '../../Object.lib';
import getDefaultModelResumeHighlights, {
  KEY__MODEL__RESUME_HIGHLIGHTS
} from './getDefaultModelResumeHighlights.fun';

export default async function fetchResumeHighlightsConfiguration() {
  try {
    const configuration = Obj(await getConfiguration({ key: KEY__MODEL__RESUME_HIGHLIGHTS }));
    if (NOT(configuration.id)) {
      Object.assign(configuration, { key: KEY__MODEL__RESUME_HIGHLIGHTS, value: getDefaultModelResumeHighlights() });
      Object.assign(configuration, Obj(await upsertConfiguration(configuration)));
    }
    return configuration;
  }
  catch (error) {
    globalErrorHandler(error);
  }
}
